import { Flex, Text } from "@chakra-ui/react";
import { useContext } from "react";
import { MdClear } from "react-icons/md";

import { ConfigurePanelHeader } from "@/design/components/configure-panel";
import { IconButton } from "@/design/components/icon-button";
import { useAppDispatch } from "@/reduxHooks.ts";

import { hidePanel } from "../..";
import { useSyncWorkflow } from "../../hooks/useSyncWorkflow";
import { setPreviewVersion } from "../../redux/workflow-slice";
import { WORKFLOW_PANELS } from "../../utils/constants";
import { ReactFlowInstanceContext } from "../flow-editor";

export const VersionHistoryHeader = () => {
  const dispatch = useAppDispatch();
  const { setNodesFn, setEdgesFn, editorInstance } = useContext(
    ReactFlowInstanceContext
  )!;
  const { refetchWorkflow, isSyncing } = useSyncWorkflow();

  const onClose = async () => {
    await refetchWorkflow(setNodesFn, setEdgesFn, editorInstance);

    dispatch(
      setPreviewVersion({
        versionTagId: null,
        versionMetaData: null,
        workflow: null,
        isCurrentVersion: false,
      })
    );
    dispatch(hidePanel(WORKFLOW_PANELS.VersionHistoryPanel));
  };
  return (
    <ConfigurePanelHeader p={4}>
      <Flex align="center" justify="space-between" w="100%">
        <Text className="text-lg font-semibold">Version History</Text>
        <IconButton
          variant="ghost"
          colorScheme="dark"
          aria-label="close panel"
          icon={<MdClear />}
          isLoading={isSyncing}
          isDisabled={isSyncing}
          onClick={onClose}
        />
      </Flex>
    </ConfigurePanelHeader>
  );
};
